import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';

export const CASHBACK_PROGRAM_TAGS = Object.freeze({
  CASHBACK_PROGRAM: 'cashback_program',
});

export const cashbackProgramApiSlice = createApi({
  reducerPath: 'cashbackProgramApiSlice',
  baseQuery,
  tagTypes: Object.values(CASHBACK_PROGRAM_TAGS),
  endpoints: (builder) => ({
    getCashbackProgram: builder.query({
      query: ({ apiManager }) => apiManager.getCashbackProgram(),
      providesTags: [CASHBACK_PROGRAM_TAGS.CASHBACK_PROGRAM],
    }),
    uploadCashbackBonusImage: builder.mutation({
      query: ({ apiManager, bonusType, data }) => apiManager.uploadCashbackBonusImage(bonusType, data),
      invalidatesTags: (_, error) => (error ? [] : [CASHBACK_PROGRAM_TAGS.CASHBACK_PROGRAM]),
    }),
    deleteCashbackBonusImage: builder.mutation({
      query: ({ apiManager, bonusType }) => apiManager.deleteCashbackBonusImage(bonusType),
      invalidatesTags: (_, error) => (error ? [] : [CASHBACK_PROGRAM_TAGS.CASHBACK_PROGRAM]),
    }),
    generateCashbackBonusImage: builder.mutation({
      query: ({ apiManager, bonusType }) => apiManager.generateCashbackBonusImage(bonusType),
    }),
  }),
});

export const {
  useGetCashbackProgramQuery,
  useUploadCashbackBonusImageMutation,
  useDeleteCashbackBonusImageMutation,
  useGenerateCashbackBonusImageMutation,
} = cashbackProgramApiSlice;
